import { HttpMethod, Maybe } from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { WORKSPACE_ROOT_ENDPOINT } from '@aibees/shared/workspace/constants/endpoints';

export function useResendInvitationEmailApi(id: Maybe<string>) {
  const workspaceId = useWorkspace()?.id;

  return useBaseMutation<any, any>({
    url: `${WORKSPACE_ROOT_ENDPOINT}/${workspaceId}/members/${id}?action=resend`,
    method: HttpMethod.put,
  });
}
